import { fromJS, List as ImmutableList } from 'immutable';
import { ANALYTICS_FORMS } from 'reporting-data/constants/dataTypes';
import { SHOW_BANNER } from 'reporting-data/constants/deprecate/deprecationTypes';
import { getDataType, getFilterByPropertyName, getReportConfig } from 'reporting-data/report/configReportGetters';
import { MEETING } from 'reporting-data/constants/formTypes';
const combinesMeetingsAndOtherForms = report => {
  const formTypeFilter = getFilterByPropertyName(getReportConfig(report), 'TYPE_ID');
  if (!formTypeFilter) {
    return true;
  } else if (formTypeFilter.get('operator') !== 'IN') {
    return false;
  }
  const values = formTypeFilter.get('values', ImmutableList());
  return values.size > 1 && values.includes(MEETING.toString());
};
const unifiedFormsMeeetingsIssue = report => getDataType(report) === ANALYTICS_FORMS && combinesMeetingsAndOtherForms(report) ? report.set('deprecation', fromJS({
  isDeprecated: true,
  type: SHOW_BANNER,
  message: 'unifiedFormsMeeetingsIssue'
})) : report;
export default unifiedFormsMeeetingsIssue;